import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
import debounce from "lodash.debounce";

class DossiersPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossiers: [],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.getDossiers = this.getDossiers.bind(this);
        this.debouncedGetDossiers = debounce(this.getDossiers, 500);
    }

    componentDidMount() {
        this.getDossiers()
    }

    handleChange(e) { 
        this.setState({ search: e.target.value, page: 1 }, () => { 
            this.debouncedGetDossiers(); 
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getDossiers();
        });
    }

    async getDossiers(){
        var url = '/api/dossiers';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({dossiers: data, total: res.data.total});
    } 

    render() {
        const { lang } = this.context; 
        return (
        <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.plantillas_de_expedientes')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.expedientes_disponibles')}</span>
                    </h3>
                    <div className="card-toolbar">
                        {this.props.dashboard=="false" &&
                            <div className="input-icon">
                                <input
                                    style={{ width: '400px' }}
                                    onChange={this.handleChange}
                                    name="search"
                                    type="text"
                                    className="form-control"
                                    placeholder={lang.get('messages.buscar_expedientes')} />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                        }
                        { this.props.top != null && this.props.dashboard=="true" &&
                            <ul className="nav nav-pills nav-pills-sm nav-dark justify-content-end">
                                <li className="nav-item ml-0">
                                    <a href="/dossiers" className="btn btn-icon-primary btn-clean btn-hover-light-primary btn-sm btn-icon">
                                        <span className="svg-icon svg-icon-lg">
                                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" strokeWidth="1">
                                                    <rect x="14" y="9" width="6" height="6" rx="3" fill="black" />
                                                    <rect x="3" y="9" width="6" height="6" rx="3" fill="black" fillOpacity="0.7" />
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                            </ul>   
                        }
                    </div>
                </div>
                <div className="card-body pt-5">
                    {this.props.dashboard=="false" &&
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="border-0">{lang.get('messages.nombre')}</th>
                                <th className="border-0">{lang.get('messages.relacion')}</th>
                                <th className="border-0">{lang.get('messages.tipo')}</th>
                                <th className="border-0">{lang.get('messages.no_de_documentos')}</th>
                                <th className="border-0"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.dossiers.map((o, i) => {
                            return <>
                                <tr key={i}>
                                    <td className=" pl-0 py-5 text-dark-75 font-weight-bolder font-size-lg d-flex align-items-center gap-1">
                                        <i className={"flaticon2-open-text-book icon-lg " + (o.active==0 ? "text-dark-50" : "text-primary")}></i>
                                        
                                        {  !this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.dossier.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.dossier.active==0 ? "text-muted" : "")}>
                                                {o.dossier.title}
                                            </a>
                                        }
                                        {  this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>
                                                {o.title}
                                            </a>
                                        }
                                        {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                    </td>
                                    <td> {lang.get('messages.'+o.target.name.toLowerCase())}</td>
                                    <td> {lang.get('messages.'+o.type.title.toLowerCase())} </td>
                                    <td>{o.documents.length}</td>
                                    <td>
                                        {  !this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.dossier.id + "/edit"}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className={"flaticon2-right-arrow icon-sm " + (o.dossier.active==0 ? "text-muted" : "text-primary")}></i>
                                                </button>
                                            </a>
                                        }
                                        {  this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.id + "/edit"}>
                                                <button className="btn btn-icon btn-light btn-xs">
                                                    <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                                </button>
                                            </a>
                                        }
                                    </td>
                                </tr>
                            </>
                        })}
                        </tbody>
                    </table>
                    }
                    {this.props.dashboard=="true" &&
                        this.state.dossiers.map((o, i) => {
                            return <div key={i}>
                                <div className="d-flex align-items-center py-2">
                                    <i className={"flaticon2-open-text-book icon-lg mr-3 " + (o.active==0 ? "text-dark-50" : "text-primary")}></i>
                                    <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                        {  !this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.dossier.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.dossier.active==0 ? "text-muted" : "")}>
                                                {o.dossier.title}
                                            </a>
                                        }
                                        {  this.props.permissions.providers_list.includes('all')   &&
                                            <a href={"/dossiers/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>
                                                {o.title}
                                            </a>
                                        }
                                        {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                    </div>
                                    {  !this.props.permissions.providers_list.includes('all')   &&
                                        <a href={"/dossiers/" + o.dossier.id + "/edit"}>
                                            <button className="btn btn-icon btn-light btn-xs">
                                                <i className={"flaticon2-right-arrow icon-sm " + (o.dossier.active==0 ? "text-muted" : "text-primary")}></i>
                                            </button>
                                        </a>
                                    }
                                    {  this.props.permissions.providers_list.includes('all')   &&
                                        <a href={"/dossiers/" + o.id + "/edit"}>
                                            <button className="btn btn-icon btn-light btn-xs">
                                                <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                            </button>
                                        </a>
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default DossiersPanel;

if (document.getElementById('DossiersPanel')) {
    ReactDOM.render(<DossiersPanel />, document.getElementById('DossiersPanel'));
}
